import Analytics, { AnalyticsInstance } from 'analytics';

import { defaultCookieAttrs } from '@consumer-frontend/api';
import { buildFullStoryPlugin } from '@consumer-frontend/shared';

import { buildAdobePlugin } from './adobe-plugin';
import { identifyCustomerId } from './datadog';

type AnalyticsWindowT = { analytics: AnalyticsInstance; } & Window;

declare let window: AnalyticsWindowT;

const isDeployed = import.meta.env.VITE_ENV === 'production' || import.meta.env.VITE_ENV === 'staging';

export const analytics = Analytics({
  app: 'contract-frontend',
  debug: !isDeployed,
  plugins: [
    buildAdobePlugin({ enabled: isDeployed }),
    buildFullStoryPlugin({ cookieAttributes: defaultCookieAttrs(), enabled: isDeployed }),
  ],
}) as AnalyticsInstance;

// resetAnalytics (libs/shared) reaches the instance through here on logout.
window.analytics = analytics;

// Identifies the customer to every analytics destination: the analytics package fans it out to
// Adobe's data layer and FullStory, and Datadog RUM gets it as its user.
export const identifyCustomer = (customerId: string) => {
  if (!customerId) return;

  analytics.identify(customerId, { customerId });
  identifyCustomerId(customerId);
};
